// extracted by mini-css-extract-plugin
export default {"divider":"index_divider__Adb-b","title":"index_title__JBFyY","shapeDesc":"index_shapeDesc__sledq"};